/**
 * 缺陷提报人映射配置 - API 接口
 */
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/constant';
import type {
  GetBugConfigPageParams,
  GetBugConfigPageResponse,
  CreateBugConfigParams,
  CreateBugConfigResponse,
  UpdateBugConfigParams,
  UpdateBugConfigResponse,
  DeleteBugConfigParams,
  DeleteBugConfigResponse,
} from '@/types/api/bugConfig';

/**
 * API 路径常量
 */
const API_PATH = {
  /** 分页查询列表 */
  GET_PAGE: '/monitor/web/jira/reporter_mapping/page_list',
  /** 新增配置 */
  CREATE: '/monitor/web/jira/reporter_mapping/add',
  /** 编辑配置 */
  EDIT: '/monitor/web/jira/reporter_mapping/edit',
  /** 删除配置 */
  DELETE: '/monitor/web/jira/reporter_mapping/delete',
};

/**
 * 获取缺陷提报人映射配置列表
 * @param params 查询参数
 * @returns 配置列表
 */
export const getBugConfigPage = async (
  params: GetBugConfigPageParams
): Promise<GetBugConfigPageResponse> => {
  return request({
    path: API_PATH.GET_PAGE,
    method: Method.POST,
    body: params,
  });
};

/**
 * 新建缺陷提报人映射配置
 * @param params 新建参数
 * @returns 新建结果
 */
export const createBugConfig = async (
  params: CreateBugConfigParams
): Promise<CreateBugConfigResponse> => {
  return request({
    path: API_PATH.CREATE,
    method: Method.POST,
    body: params,
  });
};

/**
 * 编辑缺陷提报人映射配置
 * @param params 编辑参数
 * @returns 编辑结果
 */
export const editBugConfig = async (
  params: UpdateBugConfigParams
): Promise<UpdateBugConfigResponse> => {
  return request({
    path: API_PATH.EDIT,
    method: Method.POST,
    body: params,
  });
};

/**
 * 删除缺陷提报人映射配置
 * @param params 删除参数
 * @returns 删除结果
 */
export const deleteBugConfig = async (
  params: DeleteBugConfigParams
): Promise<DeleteBugConfigResponse> => {
  return request({
    path: API_PATH.DELETE,
    method: Method.POST,
    body: params,
  });
};

/**
 * Bug Config API 对象
 */
export const bugConfigApi = {
  getPage: getBugConfigPage,
  create: createBugConfig,
  edit: editBugConfig,
  delete: deleteBugConfig,
};

export default bugConfigApi;
